import { combineReducers } from 'redux';
import pick from 'lodash/pick';
import accountUpgrade from './accountUpgrade';
import contactDetails from './contactDetails';
import payments from './payments';
import features from './features';
import billingAddress from './billingAddress';
import exportStatus from './exportStatus';
import billingContacts from './billingContacts';
import currentInvoice from './currentInvoice';
import { GET_ACCOUNT_DETAILS_DONE } from '../actions';
import businessHourTemplatesData from './fetchBusinessHourTemplates';
import businessHourTemplate from './businessHourTemplates';
import {contactsReducer} from '../components/contacts/redux/reducer'
import { userProvisioningReducer } from '../components/UserProvisioning/Common/redux/reducers';



const general = (state = {}, action) => {
    const details = [
        'planName', 'planType', 'nextBillDate', 'invoices', 'proratingfactor', 
        'userGroupState', 'stripeCustomer', 'StripePublishKey', 'stripe_id',
        'userBought', 'userGroupDiscount'
    ];
    switch(action.type) {
        case GET_ACCOUNT_DETAILS_DONE:
            return { ...state, ...pick(action.payload, details) };
        default:
            return state;
    }
}

const accountDetails = combineReducers({
    contactDetails,
    billingContacts,
    payments,
    features,
    billingAddress,
    exportStatus,
    general
   
});

export default combineReducers({
    accountDetails,
    accountUpgrade,
    currentInvoice,
    businessHourTemplate,
    businessHourTemplatesData,
    contacts: contactsReducer,
    userProvisioning: userProvisioningReducer,
});
